import * as React from 'react';
import {usePress, useLongPress, mergeProps, LongPressProps, PressHookProps} from 'react-aria';

export interface PressableProps extends PressHookProps, LongPressProps {}

/**
 * A generic, accessible pressable component for interactive content.
 * @param props PressableProps
 */
export function Pressable(props: PressableProps) {
  const {longPressProps} = useLongPress(props);
  const {pressProps} = usePress(props);
  const merged = mergeProps(pressProps, longPressProps);
  return <div {...merged} />;
}
